<template>
	<div>
		<el-popover
			placement="bottom"
			width="450"
			height="300"
			trigger="click"
			:value="value"
      :disabled="disabled"
			@input="val => $emit('input', val)"
		>
			<li class="emojiList" v-for="(item, index) in emojis" :key="index" @click="handleEmoji(item)">
				{{ item.text }}
			</li>
			<img slot="reference" :src="biaoqing" style="margin-left: 10px" />
		</el-popover>
	</div>
</template>

<script>
import biaoqing from '@/assets/richText/biaoqing.png';
export default {
	name: 'emoji',
	props: {
		value: null,
    disabled: false
	},
	data() {
		return {
			biaoqing,
			emojis: [],
		};
	},
	mounted() {
		var emojis = [
			'😀',
			'😃',
			'😄',
			'😁',
			'😆',
			'😅',
			'🤣',
			'😂',
			'🙂',
			'🙃',
			'😉',
			'😊',
			'😇',
			'🥰',
			'😍',
			'🤩',
			'😘',
			'😗',
			'😙',
			'😋',
			'😜',
			'🤪',
			'😝',
			'🤗',
			'😐',
			'🙄',
			'😪',
			'😴',
			'😷',
			'😵',
			'🥳',
			'😎',
			'🤓',
			'☹️',
			'😮',
			'😳',
			'😨',
			'😰',
			'😭',
			'😱',
			'😖',
			'😣',
			'😓',
			'😠',
			'🤮',
			'🥵',
			'👋',
			'🤚',
			'🖐️',
			'✋',
			'👌',
			'🤞',
			'🤟',
			'👈',
			'👉',
			'👆',
			'👇',
			'👍',
			'👏',
			'🤝',
			'🙏',
			'💪',
			'☀️',
			'🌙',
			'✨',
			'🌹',
			'🥀',
			'🌻',
			'💣',
			'🔥',
			'😺',
			'😹',
			'😻',
			'💩',
			'💀',
			'👽',
		];

		this.emojis = emojis.map(emoji => ({ text: emoji }));
	},
	methods: {
		handleEmoji(item) {
			this.$emit('select', item.text);
		},
	},
	components: {},
};
</script>
<style lang="scss" scoped>
.emojiList {
	display: inline;
	font-size: 18px;
	cursor: pointer;
}
</style>
